import { render, staticRenderFns } from "./TableCareList.vue?vue&type=template&id=8cbafe6c&scoped=true"
import script from "./TableCareList.vue?vue&type=script&lang=js"
export * from "./TableCareList.vue?vue&type=script&lang=js"
import style0 from "./TableCareList.vue?vue&type=style&index=0&id=8cbafe6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbafe6c",
  null
  
)

export default component.exports